   <template>
   
    <!--公用弹框-->
    <div class="popbox" id="popbox-tishi2" style="display:block">
      <div class="popbox-inner">
          <div class="popbox-header">{{title}}<a class="popbox-close" href="javascript:void(0)" @click="ensure()" style="display: none">&times;</a></div>
          <div class="popbox-body" style="font-size:0.4rem;" v-html="content">  
            {{content}}
          </div>
          <div class="popbox-footer">
            <div class="yld-footer-btns clearfix">
              <button class="yld-footer-btn" type="button" @click="ensure()">确定</button>
            </div>
          </div>
      </div>
    </div>
    <!--//公用弹框-->
    
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      title: null,
      content: null,
      ensureFunc: null
    };
  },
  methods: {
    ensure() {
      $("#popbox-tishi2").remove();
      if(this.ensureFunc!=null){
        this.ensureFunc();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/MessageBox/MessageBox.vue